import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-body p-xl-20" }
const _hoisted_2 = { class: "table-responsive border-0" }
const _hoisted_3 = {
  class: "table align-middle mb-0",
  style: {"table-layout":"fixed","width":"100%"}
}
const _hoisted_4 = { class: "bg-light" }
const _hoisted_5 = {
  scope: "col",
  class: "text-title fw-bold fs-13 py-2 ps-3 border-0 rounded-start",
  style: {"width":"45%"}
}
const _hoisted_6 = {
  scope: "col",
  class: "text-title fw-bold fs-13 py-2 text-center border-0",
  style: {"width":"25%"}
}
const _hoisted_7 = {
  scope: "col",
  class: "text-title fw-bold fs-13 py-2 text-end border-0",
  style: {"width":"20%"}
}
const _hoisted_8 = { class: "shadow-none lh-1 fs-13 fw-normal text-paragraph ps-3 border-0 py-3" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "fs-13" }
const _hoisted_11 = { class: "d-flex align-items-center text-muted gap-2 flex-wrap mt-1" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = ["value", "onChange"]
const _hoisted_14 = { value: null }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = ["value", "onChange"]
const _hoisted_18 = {
  key: 0,
  value: null
}
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 0,
  class: "badge rounded-pill text-bg-warning-subtle text-warning-emphasis border border-warning border-opacity-25"
}
const _hoisted_21 = { class: "shadow-none lh-1 fs-13 fw-normal text-paragraph border-0 py-3" }
const _hoisted_22 = {
  class: "d-flex align-items-center justify-content-center bg-transparent rounded-pill px-2 py-1 mx-auto",
  style: {"width":"fit-content"}
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "mx-3 fs-14 fw-bold text-dark" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "shadow-none lh-1 fs-14 fw-bold text-dark text-end border-0 py-3" }
const _hoisted_27 = { class: "shadow-none lh-1 text-end pe-3 border-0 py-3" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  colspan: "4",
  class: "text-center py-5 text-muted border-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_4, [
            _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("pos.product")), 1),
            _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("pos.qty")), 1),
            _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("pos.subtotal")), 1),
            _cache[0] || (_cache[0] = _createElementVNode("th", {
              scope: "col",
              class: "text-title fw-bold fs-13 py-2 text-end pe-3 border-0 rounded-end",
              style: {"width":"10%"}
            }, null, -1))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateStore.selectedProducts, (product) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: product.id,
              class: "border-bottom-dashed"
            }, [
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("div", {
                  class: "fw-bold text-dark mb-1 text-truncate",
                  title: product.name
                }, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(product.code) + " - " + _toDisplayString(product.name), 1)
                ], 8, _hoisted_9),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t("pos.size")) + " : ", 1),
                    _createElementVNode("select", {
                      class: "form-select border-0 bg-transparent text-secondary py-0 px-2 shadow-none variant-select rounded-pill",
                      value: product.size_id,
                      onChange: (e) => _ctx.updateVariation(product.id, 'size', e.target.value ? parseInt(e.target.value) : null)
                    }, [
                      _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.hasProductSizes(product) ? _ctx.$t("pos.choose_size") : _ctx.$t("common.none")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableSizes(product), (size) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: size.id,
                          value: size.id
                        }, _toDisplayString(size.name), 9, _hoisted_15))
                      }), 128))
                    ], 40, _hoisted_13)
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fs-12 text-secondary" }, "•", -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t("pos.sugar")) + " : ", 1),
                    _createElementVNode("select", {
                      class: "form-select border-0 bg-transparent text-secondary py-0 px-2 shadow-none variant-select rounded-pill",
                      value: product.sugar_id,
                      onChange: (e) => _ctx.updateVariation(product.id, 'sugar', e.target.value ? parseInt(e.target.value) : null)
                    }, [
                      (product.type === 1)
                        ? (_openBlock(), _createElementBlock("option", _hoisted_18, _toDisplayString(_ctx.$t("common.none")), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sugars, (sugar) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: sugar.id,
                          value: sugar.id
                        }, _toDisplayString(sugar.name), 9, _hoisted_19))
                      }), 128))
                    ], 40, _hoisted_17)
                  ]),
                  (_ctx.getPromotionLabel(product))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.getPromotionLabel(product)), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("td", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary border-0 p-0 d-flex align-items-center justify-content-center rounded-circle bg-light shadow-none",
                    style: {"width":"26px","height":"26px","font-size":"14px","line-height":"1","padding-bottom":"2px !important"},
                    onClick: ($event: any) => (_ctx.updateQty(product.id, product.qty - 1))
                  }, "-", 8, _hoisted_23),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(product.qty), 1),
                  _createElementVNode("button", {
                    class: "btn btn-outline-primary border-0 p-0 d-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary shadow-none",
                    style: {"width":"26px","height":"26px","font-size":"14px","line-height":"1"},
                    onClick: ($event: any) => (_ctx.updateQty(product.id, product.qty + 1))
                  }, "+", 8, _hoisted_25)
                ])
              ]),
              _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.getLineTotal(product))), 1),
              _createElementVNode("td", _hoisted_27, [
                _createElementVNode("button", {
                  class: "btn p-1 border-0 text-danger",
                  onClick: ($event: any) => (_ctx.removeProduct(product.id))
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "ri-delete-bin-line fs-18" }, null, -1)
                ]))], 8, _hoisted_28)
              ])
            ]))
          }), 128)),
          (_ctx.stateStore.selectedProducts.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                _createElementVNode("td", _hoisted_30, [
                  _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-shopping-cart-2-line fs-1 d-block mb-2 text-light" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("pos.no_products_selected")), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}